module.exports = __webpack_public_path__ + "media/game_dot_01.22c09c2b.mp4";